/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Redact_Before_NoteInputs */

const da_forside_redact_before_note = /** @type {(inputs: Forside_Redact_Before_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalen og filnavnet bliver her.`)
};

/** @type {(inputs: Forside_Redact_Before_NoteInputs) => LocalizedString} */
const en_forside_redact_before_note = da_forside_redact_before_note;

/**

* @param {Forside_Redact_Before_NoteInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_redact_before_note = /** @type {((inputs?: Forside_Redact_Before_NoteInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Redact_Before_NoteInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_redact_before_note(inputs)
	return /** @type {LocalizedString} */ ("Originalen og filnavnet bliver her.")
});